module.exports = __webpack_public_path__ + "img/01-T.b0eeffba.png";